module.exports = {
    language: {
        name: '中文'
    },
    header: ['首页','关于我们','新闻资讯','我们的IP','业务范围','新零售','联系我们'],
    main: {
        aboutUs: '关于我们',
        news: '新闻资讯',
        ourIp: '我们的IP',
        link: '友情链接',
        contactUs: '联系我们',
        aboutList: [],
        newsList: [],
    },
    about:{
        ip:'关于IP',
        banner:'',
        produce:'',
        ipList:[],//所有的轮播图的数据[[],[],[]]
        ipListActive:[],//当前的一个轮播图的数据['','','']
        ipItemList:[],//默认展示的图片
        ipItemListActive:[],//点击激活时候的图片
        coreBusiness:''
    },
    news:{
        banner:''
    },
    ip:{
        bannerList:[],
        ipNewsTitle:'IP新闻'
    },
    market:{

    },
    store: {
        banner:[],
        storeList:[]
    },
    channels:{
        bannerList:[]
    }
}